import DOMReady from '../utils/DOMReady'

// eslint-disable-next-line no-unused-vars
import css from '../../css/blocks/reservation-form.scss'
import ReservationForm from '../modules/reservation-form'

class ReservationFormBlock {
  constructor(el) {
    this.container = el
    this.formEl = this.container.querySelector('.form')

    if (this.form !== null) {
      this.form = new ReservationForm(this.formEl)
    }
  }
}

DOMReady(() => {
  const elements = document.querySelectorAll('.reservation-form')
  if (elements !== null) {
    elements.forEach(element => new ReservationFormBlock(element))
  }
})
